import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

class AgentLinksWrapper extends React.Component {
  render(){
    const { agent, mediaLinks, render } = this.props

    if (!agent.media_links) return null

    return render({
      mediaLinks: agent.media_links.map((mediaLinkId) => {
        const mediaLink = mediaLinks[mediaLinkId] || {}
        return mediaLink
      }),
    })
  }
}

AgentLinksWrapper.propTypes = {
  agent: PropTypes.object.isRequired,
  mediaLinks: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state){
  const { mediaLinks } = state.entities
  return {
    mediaLinks,
  }
}

export default connect(mapStateToProps)(AgentLinksWrapper)
